import React, { ChangeEvent, FC, InputHTMLAttributes, useEffect, useRef } from 'react';
import { StyledInput, StyledInputContainer } from './InputPin.css';

export interface PinInputProps extends InputHTMLAttributes<HTMLInputElement> {
    numberOnly?: boolean;
    showDuration?: number;
    isInvalid?: boolean;
    isActive: boolean;
    value: string;
    index: number;
    label?: string;
}

export const PinInput: FC<PinInputProps> = ({
    value = '',
    numberOnly = true,
    showDuration = 1000,
    onChange,
    isActive,
    isInvalid = false,
    index,
    label,
    ...rest
}) => {
    const inputRef = useRef<HTMLInputElement>(null);
    const previouslyActive = useRef(false);

    useEffect(() => {
        if (isActive && !previouslyActive.current && inputRef.current) {
            inputRef.current.focus();
        }
        previouslyActive.current = isActive;
    }, [isActive]);

    const onInputChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (numberOnly && e.target.value.match(/^\d?$/)) {
            if (onChange) {
                onChange(e);
            }
        }
    };

    return (
        <StyledInputContainer data-test-id={'header-settingsbuttons-enter-pin'}>
            <input
                type={'password'}
                id={`new-password-${index}`}
                name={`new-password-${index}`}
                style={{ display: 'none' }}
                autoComplete={'new-password'}
                tabIndex={-1}
                aria-hidden
            />

            <StyledInput
                value={value}
                readOnly={false}
                isActive={isActive}
                ref={inputRef}
                isInvalid={isInvalid}
                maxLength={1}
                index={index}
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                data-pin-input
                onChange={onInputChange}
                required={true}
                placeholder={'○'}
                aria-invalid={isInvalid}
                aria-label={label}
                autoComplete={'new-password'}
                showDuration={showDuration}
                {...rest}
            />
            <span aria-hidden="true">●</span>
        </StyledInputContainer>
    );
};
